/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Sunday, March 6th 2022, 9:16:06 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import "theme/css/FormBuilder.css";
import { useParams } from "react-router";
import ShareIcon from "@mui/icons-material/Share";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { FormConfiguration } from "lib/schemas";
import { FormBuilder } from "form-builder/components";
import { ShareFormSubmissionLink } from "form-builder/components/ShareFormSubmissionLink";
import { useServiceBuilderContext } from "service-builder/providers";
import { useFormBuilderStore, currentFormSelector } from "form-builder/stores";

export const ServiceFormBuilderPage = () => {
  const { formId } = useParams();

  const {
    updateTemplateArtifactsOnAPISaveFormConfiguration,
    processDefinitionContext: { currentProcessDefinition },
  } = useServiceBuilderContext();

  const onUpdateFormInfo = React.useCallback(
    (updatedFormConfig: FormConfiguration) => {
      updateTemplateArtifactsOnAPISaveFormConfiguration(updatedFormConfig, updatedFormConfig.form_type);
    },
    [updateTemplateArtifactsOnAPISaveFormConfiguration] //Ensuring we always call the correct instance of the memoized functions
  );

  const currentFormConfiguration = useFormBuilderStore(currentFormSelector);

  const showShareSubmissionLink = currentFormConfiguration?.form_type === "application_form";

  const shareSubmissionLinkComponent = showShareSubmissionLink && (
    <ShareFormSubmissionLink
      processDefinitionId={currentProcessDefinition.id}
      processDefinitionSiteURL={currentProcessDefinition.site_url}
      formTitle={currentFormConfiguration.title}
      formSlug={currentFormConfiguration.slug}
      formType={currentFormConfiguration.form_type}
    >
      {({ handleOpen }) => (
        <Tooltip title={<Typography>Share Submission Link</Typography>}>
          <IconButton color="secondary" onClick={handleOpen}>
            <ShareIcon />
          </IconButton>
        </Tooltip>
      )}
    </ShareFormSubmissionLink>
  );

  return (
    <FormBuilder
      formId={formId}
      onUpdateFormInfo={onUpdateFormInfo}
      shareSubmissionLinkComponent={shareSubmissionLinkComponent}
    />
  );
};
